import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Job & Project Module Service Stores
 * Updated to match backend api-types
 *
 * Note: Job services don't have a dedicated api-types folder.
 * Related services may be found in the project api-types folder.
 */
export const jobStores: ServiceStoreConfig[] = [
  // No job-specific api-types exist yet
  // Project-related services are in a separate project module
];
